/* Hero name captions: show who is on screen, in sync with the montage (assets/data/montage-cues.json). */
(function () {
  var v = document.querySelector("video[data-cues]"), box = document.querySelector(".hero__cue");
  if (!v || !box || !window.fetch) return;
  var n = box.querySelector(".hero__cue-n"), s = box.querySelector(".hero__cue-s"), cues = [], cur = -1;
  fetch(v.getAttribute("data-cues")).then(function (r) { return r.json(); }).then(function (c) { cues = c; tick(); });
  function tick() {
    var t = v.currentTime, i = -1;
    for (var k = 0; k < cues.length; k++) { var nx = cues[k + 1], end = nx && nx.t - cues[k].e < 0.05 ? nx.t : cues[k].e - 0.08; if (t >= cues[k].t && t < end) { i = k; break; } }
    if (i !== cur) {
      cur = i;
      var back = i > 0 && cues[i - 1] && Math.abs(cues[i].t - cues[i - 1].e) < 0.05 && box.classList.contains("is-on");
      if (i < 0) box.classList.remove("is-on");
      else if (back) { n.textContent = cues[i].name; s.textContent = cues[i].sub || ""; }
      else { n.textContent = cues[i].name; s.textContent = cues[i].sub || ""; box.classList.remove("is-on"); void box.offsetWidth; box.classList.add("is-on"); }
    }
    requestAnimationFrame(tick);
  }
})();
